module["exports"] = [
  "სოფელი",
  "ძირი",
  "სკარი",
  "დაბა"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/address/city_suffix.js
// module id = 1220
// module chunks = 0